import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { ErrorPage } from "@/components";
import { ErrorPageType, PermissionRoles } from "@/enum";

import { useHasPermissions } from "@/utils/useHasPermissions";

import ToDoList from "./ToDoList/ToDoList";
import { ToDoSocketProvider } from "./ToDoList/providers/SocketContext";
import ManageToDos from "./ManageToDos/ManageToDos";

export const ToDo: FunctionComponent = () => {
	const { hasPermissions } = useHasPermissions();

	return (
		<Routes>
			<Route
				element={
					<ToDoSocketProvider>
						<ToDoList />
					</ToDoSocketProvider>
				}
				path="/"
			/>
			{hasPermissions([PermissionRoles.GLOBAL_ADMIN]) && (
				<Route element={<ManageToDos />} path="/manage" />
			)}
			<Route element={<ErrorPage type={ErrorPageType.NotFound} />} path="*" />
			<Route element={<ErrorPage type={ErrorPageType.Forbidden} />} path="/error-page" />
		</Routes>
	);
};
